export default "__VITE_ASSET__BTZsGe0R__";